jQuery(document).ready(function($) {
    // Announcement bar is now a static banner (see custom.css .announcement-slider) —
    // no longer initialized as a Slick carousel.

    $('body').on('click', '.load-morewrap a', function(e) {
        e.preventDefault();
        var href = $(this).attr("href");
        if (!href) return;
        $.ajax({
            url: href,
            type: "GET",
            beforeSend: function() { $("#loader").show(); },
            success: function(data) {
                var newContent = $(data).find("#loadmorenews").html();
                if (newContent) $("#loadmorenews").append(newContent);
                var newPagination = $(data).find(".load-morewrap").html();
                if (newPagination) {
                    $(".load-morewrap").html(newPagination);
                } else {
                    $(".load-morewrap").remove();
                }
            },
            error: function() {
                console.error("Failed to load more content.");
            },
            complete: function() { $("#loader").hide(); }
        });
    });

    $("#key-ingredients").click(function() {
        $("body").toggleClass("sidebar-show");
    });

    $(".hamburger-nav-close").click(function() {
        $("body").removeClass("sidebar-show");
    });

    $(".add-to-cart-form").click(function() {
        $("body").addClass("changeCursor");
    });

    $(".drawer__close").click(function() {
        $("body").removeClass("changeCursor");
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const widget = document.querySelector('.hanging-widget');

    function checkPage() {
        if (widget) {
            if (window.location.pathname === '/products/brightening-hyper-c-serum') {
                widget.style.display = 'flex';
                widget.addEventListener('click', function() {
                    window.location.href = "/cart";
                });
            } else {
                widget.style.display = 'none';
            }
        }
    }

    checkPage();
    window.addEventListener('popstate', checkPage);

    const intervalId = setInterval(function() {
        const hiddenElements = document.querySelectorAll('.delivery-hidden');
        if (hiddenElements.length === 0) {
            clearInterval(intervalId);
            return;
        }
        hiddenElements.forEach(function(el) { el.remove(); });
    }, 500);
});

jQuery(document).ready(function($) {
    $('.view-result').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#custom-image-section').offset().top
        }, 800);
    });
});